import React from "react";
import { Link } from "react-router-dom";
import { Store, Gift, Repeat } from "lucide-react";
import { photoUrl, priceLabel } from "../../lib/market";
import { SaveButton } from "./SaveButton";

const KIND = { free: { l: "Free", I: Gift, c: "bg-emerald-600" }, rental: { l: "Rent", I: Repeat, c: "bg-[var(--ink)]" } };

export function ListingCard({ l }) {
  const k = KIND[l.kind];
  return (
    <Link to={`/market/item/${l.listing_id}`} className="group block" data-testid={`market-card-${l.listing_id}`}>
      <div className="relative aspect-[4/5] rounded-2xl overflow-hidden bg-[var(--bg-warm)]">
        <img src={photoUrl(l.photos?.[0])} alt={l.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        {k && <span className={`absolute top-3 left-3 ${k.c} text-white text-[10px] uppercase tracking-[0.15em] px-2.5 py-1 rounded-full flex items-center gap-1`}><k.I className="w-3 h-3" /> {k.l}</span>}
        {l.status === "active" && <SaveButton id={l.listing_id} />}
        {l.status === "sold" && <span className="absolute inset-0 bg-black/50 flex items-center justify-center text-white font-serif text-3xl">Sold</span>}
      </div>
      <p className="font-medium mt-3 truncate">{l.title}</p>
      <p className="text-sm flex items-center justify-between gap-2">
        <span className="font-semibold" data-testid={`market-card-price-${l.listing_id}`}>{priceLabel(l)}</span>
        <span className="text-xs text-[var(--muted)] truncate flex items-center gap-1">{l.seller_type === "store" && <Store className="w-3 h-3 text-[var(--gold)]" />}{l.location || l.seller_name}</span>
      </p>
    </Link>
  );
}
